module.exports = __webpack_public_path__ + "static/media/product1-2.d55bf762.png";